import { showLoader, hideLoader } from "./utilities/loader.js";
import Product from "./product.js";
import Validation from "./utilities/validation.js";
import Messages from "./utilities/messages.js";
import PartnerShop from "./shortcodes/partner-shop.js";
import Whatsapp from "./misc/whatsapp.js";
import StickyHeader from "./design/sticky-header.js";
import PopupManager from "./design/popup.js";
import Order from "./order.js";
import Scroll from "./utilities/scroll.js";
import CollapsiblePanel from "./shortcodes/collapsible-panel.js";
import CurrencyCalculator from "./misc/currency-calculator.js";
import Faq from "./design/faq.js";

const $ = window.jQuery || {};

class Main {
  constructor() {
    this.orderForm = $(".lightglobal-forward.order-form");
    this.productLinks = this.orderForm.find(".product-links");
    this.submitOrderButton = $(".lightglobal-forward.order-form .submit-order");
    this.messages = new Messages();
    this.validation = new Validation();
    this.partnerShop = new PartnerShop();
    this.whatsapp = new Whatsapp("66940519935");
    this.websiteUrl = siteUrl.url;
    this.order = new Order();
    this.scroll = new Scroll();
    this.faq = new Faq(".faq-wrapper");
    this.collapsiblePanel = new CollapsiblePanel(
      ".lightglobal-forward--collapsible-panel"
    );
    this.currencyCalculator = new CurrencyCalculator();

    this.init();
  }

  init() {
    const stickyHeader = new StickyHeader();
    this.bindEvents();
    this.checkCartState();
  }

  bindEvents() {
    this.productLinks.on("input", () => {
      this.productLinks.find(".error-message").hide();
    });

    $(".add-link").on("click", (e) => {
      e.preventDefault();
      let link = $('input[name="product_link"]').val();

      if (!this.validation.isValidUrl(link)) {
        link = this.validation.removeQueryFromUrl(link);
        if (!this.validation.isValidUrl(link)) {
          this.messages.showError(
            $("#error-message"),
            "Не ссылка. Пожалуйста, введите корректную ссылку на товар."
          );
          return;
        }
      }

      // if (!this.validation.isKnownDomain(link)) {
      //   this.messages.showError(
      //     $("#error-message"),
      //     "Неверная ссылка. Пожалуйста, введите корректную ссылку на товар из магазина-партнера."
      //   );
      //   return;
      // }

      const quantity = $('input[name="product_quantity"]').val();
      const comment = $('textarea[name="product_comment"]').val();
      var order_note = "";

      if ($('input[name="search_option"]:checked').val() == "need_search") {
        order_note += "Требуется поиск нужного товара.";
      } else {
        order_note += "Товар найден самостоятельно.";
      }
      const data = { link, quantity, comment, order_note };
      if (data) {
        this.productLinks.loader("show");
        Product.parseProductLink(data, (err, data) => {
          if (err) {
            console.error(err);
          } else {
            this.orderForm.find("form")[0].reset();
            $(document.body).trigger("wc_fragments_refreshed");
            this.enableSubmitButton();
          }
          this.productLinks.loader("hide");
        });
      }
    });

    this.orderForm.find("form").on("submit", (e) => {
      e.preventDefault();
      this.orderForm.loader("show");
      window.location.href = this.websiteUrl + "/checkout";
    });

    $(".close-btn").on("click", (e) => {
      $(e.target).closest(".lightglobal-forward").hide();
    });

    $("#lightglobal-forward__order-form .info-icon").on("click", (e) => {
      this.infoPopUp = new PopupManager({
        title: "Услуги байера",
        content: `<p>Если вам требуется байер, выберите ниже нужный параметр. Если Байер не требуется, то ничего не выбирайте.</p>
        <p><strong>Байер</strong> &mdash; это специалист, который помогает купить товары за рубежом и доставить их в Вашу страну. Работая с байером, вы можете купить товары недоступных в Вашей стране производителей или просто сэкономить: часто в зарубежных магазинах те же вещи стоят дешевле, чем в локальных.</p>
        <p>Стоимость услуг байера зависит от адреса продажи товара.</p>
        <ul>
        <li><em>Знаю, где купить товар</em> &mdash; нужен выезд для покупки в конкретный офлайн-магазин, ссылку на магазин дадите вы. Стоимость услуг байера от <strong>300 бат</strong> (&asymp;900 руб). Оплата производится за поездку, в независимости от результата покупки.</li>
        <li><em>Нужен поиск товара</em> &mdash; у вас есть изображение/название товара, но вы не знаете, где он продается. Байер осуществит поиск товара по всем доступным магазинам и интернет-площадкам. Стоимость услуг байера зависит от <strong>500 бат</strong> (&asymp;1500 руб)</li>
        </ul>`,
      });
      this.infoPopUp.open();
    });

    $(".lightglobal-forward--services #lightglobal-forward__tariff-light").on(
      "click",
      (e) => {
        this.infoPopUp = new PopupManager({
          title: "Тариф - Лайт",
          content: `<table id="table__tariff-light" width="705">
      <thead>
      <tr>
      <td width="146">
      <p style="text-align: center;"><strong>Вес, кг</strong></p>
      </td>
      <td style="text-align: center;" width="316"><strong>Тариф на перевозку посылок от офиса Light Logistics в Таиланде до двери клиента в&nbsp; РФ</strong></td>
      <td width="243">
      <p style="text-align: center;"><strong>Зона повышенной стоимости</strong></p>
      </td>
      </tr>
      </thead>
      <tbody>
      <tr>
      <td width="146">
      <p style="text-align: center;">До 0,5</p>
      </td>
      <td style="text-align: center;" width="316">390 THB</td>
      <td width="243">
      <p style="text-align: center;">530 THB</p>
      </td>
      </tr>
      <tr>
      <td width="146">
      <p style="text-align: center;">0,501 — 1</p>
      </td>
      <td style="text-align: center;" width="316">690 THB</td>
      <td style="text-align: center;" width="243">980 THB</td>
      </tr>
      <tr>
      <td style="text-align: center;" width="146">1,001 — 1,5</td>
      <td style="text-align: center;" width="316">950 THB</td>
      <td width="243">
      <p style="text-align: center;">1 180 THB</p>
      </td>
      </tr>
      <tr>
      <td width="146">
      <p style="text-align: center;">1,501 — 2</p>
      </td>
      <td style="text-align: center;" width="316">1 190 THB</td>
      <td style="text-align: center;" width="243">1 380 THB</td>
      </tr>
      <tr>
      <td style="text-align: center;" width="146">2,001 — 2,5</td>
      <td style="text-align: center;" width="316">1 480 THB</td>
      <td width="243">
      <p style="text-align: center;">1 580 THB</p>
      </td>
      </tr>
      <tr>
      <td width="146">
      <p style="text-align: center;">2,501 — 3</p>
      </td>
      <td style="text-align: center;" width="316">1 660 THB</td>
      <td style="text-align: center;" width="243">1 860 THB</td>
      </tr>
      <tr>
      <td style="text-align: center;" width="146">3,001 — 4</td>
      <td style="text-align: center;" width="316">2 080 THB</td>
      <td width="243">
      <p style="text-align: center;">2 390 THB</p>
      </td>
      </tr>
      <tr>
      <td width="146">
      <p style="text-align: center;">4,001 — 5</p>
      </td>
      <td style="text-align: center;" width="316">2 430 THB</td>
      <td style="text-align: center;" width="243">2 980 THB</td>
      </tr>
      <tr>
      <td style="text-align: center;" width="146">5,001 — 6</td>
      <td style="text-align: center;" width="316">2 850 THB</td>
      <td width="243">
      <p style="text-align: center;">3 580 THB</p>
      </td>
      </tr>
      <tr>
      <td width="146">
      <p style="text-align: center;">6,001 — 7</p>
      </td>
      <td style="text-align: center;" width="316">3 190 THB</td>
      <td style="text-align: center;" width="243">4 240 THB</td>
      </tr>
      <tr>
      <td style="text-align: center;" width="146">7,001 — 8</td>
      <td style="text-align: center;" width="316">3 490 THB</td>
      <td width="243">
      <p style="text-align: center;">4 830 THB</p>
      </td>
      </tr>
      <tr>
      <td width="146">
      <p style="text-align: center;">8,001 — 9</p>
      </td>
      <td style="text-align: center;" width="316">3 890 THB</td>
      <td style="text-align: center;" width="243">5 340 THB</td>
      </tr>
      <tr>
      <td style="text-align: center;" width="146">9,001 — 10</td>
      <td style="text-align: center;" width="316">4 390 THB</td>
      <td width="243">
      <p style="text-align: center;">5 700 THB</p>
      </td>
      </tr>
      </tbody>
      </table>`,
        });
        this.infoPopUp.open();
      }
    );

    $(
      ".lightglobal-forward--services #lightglobal-forward__tariff-light-shop"
    ).on("click", (e) => {
      this.infoPopUp = new PopupManager({
        title: "Тариф - Глобал Байер",
        content: `<table id="table__tariff-light-shop">
      <thead>
        <tr>
          <th><p>Вес, кг</p></th>
          <th><p>Тариф на перевозку посылок от офиса Light Logistics в Таиланде до двери клиента в РФ</p></th>
          <th><p>Зона повышенной стоимости</p></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><p>До 0,5</p></td>
          <td><p>390 THB</p></td>
          <td><p>445 THB</p></td>
        </tr>
        <tr>
          <td><p>0,501 — 1</p></td>
          <td><p>640 THB</p></td>
          <td><p>850 THB</p></td>
        </tr>
        <tr>
          <td><p>1,001 — 1,5</p></td>
          <td><p>880 THB</p></td>
          <td><p>1 080 THB</p></td>
        </tr>
        <tr>
          <td><p>1,501 — 2</p></td>
          <td><p>1 090 THB</p></td>
          <td><p>1 290 THB</p></td>
        </tr>
        <tr>
          <td><p>2,001 — 2,5</p></td>
          <td><p>1 340 THB</p></td>
          <td><p>1 550 THB</p></td>
        </tr>
        <tr>
          <td><p>2,501 — 3</p></td>
          <td><p>1 550 THB</p></td>
          <td><p>1 880 THB</p></td>
        </tr>
        <tr>
          <td><p>3,001 — 4</p></td>
          <td><p>1 920 THB</p></td>
          <td><p>2 390 THB</p></td>
        </tr>
        <tr>
          <td><p>4,001 — 5</p></td>
          <td><p>2 290 THB</p></td>
          <td><p>2 960 THB</p></td>
        </tr>
        <tr>
          <td><p>5,001 — 6</p></td>
          <td><p>2 690 THB</p></td>
          <td><p>3 480 THB</p></td>
        </tr>
        <tr>
          <td><p>6,001 — 7</p></td>
          <td><p>3 090 THB</p></td>
          <td><p>3 990 THB</p></td>
        </tr>
        <tr>
          <td><p>7,001 — 8</p></td>
          <td><p>3 380 THB</p></td>
          <td><p>4 540 THB</p></td>
        </tr>
        <tr>
          <td><p>8,001 — 9</p></td>
          <td><p>3 790 THB</p></td>
          <td><p>5 110 THB</p></td>
        </tr>
        <tr>
          <td><p>9,001 — 10</p></td>
          <td><p>4 290 THB</p></td>
          <td><p>5 640 THB</p></td>
        </tr>
      </tbody>
    </table>`,
      });
      this.infoPopUp.open();
    });

    $(".service-panel__more").on("click", function (e) {
      e.preventDefault();

      const popupId = $(this).data("popup");
      let popupContent = "";
      let popupTitle = "";

      if (popupId === "popup-consolidation") {
        popupTitle = "Консолидация и упаковка";
        popupContent = `
                <table class="popup-table">
                    <tr>
                        <td>Консолидация</td>
                        <td>0 руб</td>
                    </tr>
                    <tr>
                        <td>Упаковка посылок</td>
                        <td>0 руб</td>
                    </tr>
                </table>
                <p>Мы бесплатно объединим ваши покупки и отправим их вам, вашим друзьям или клиентам по выгодной стоимости.</p>
            `;
      } else if (popupId === "popup-storage") {
        popupTitle = "Хранение посылок";
        popupContent = `
                <p><strong>Хранение входящих посылок на складе:</strong> 45 дней бесплатно, на следующий день и далее 100 ₽ в день за одну посылку. Максимальный срок хранения груза — 60 дней. Далее посылка утилизируется.</p>
                <p><strong>Хранение исходящей посылки без оплаты доставки со статусом «ожидает оплаты»:</strong> 10 дней бесплатно, на следующий день и далее 100 ₽ в день за одну посылку. Максимальный срок хранения груза — 30 дней. Далее посылка утилизируется.</p>
            `;
      }

      const popup = new PopupManager({
        title: popupTitle,
        content: popupContent,
      });

      popup.open();
    });

    // on calculator button .calc-button click open calculator popup
    $(".calc-button").on("click", function (e) {
      e.preventDefault();
      const popup = new PopupManager({
        title: "Калькулятор заказа",
        content: `
      <div class="currency-calculator">
        <form id="calcForm">
            <label for="orderPrice">Введите сумму заказа в тайских батах:</label>
            <input type="number" id="orderPrice" min="0" placeholder="Сумма заказа в тайских батах" />

            <p>Сколько нужно заплатить (приблизительно):</p>
            <div id="rubAmount">0.00 руб.</div>

            <p class="info">Курс обмена может измениться. Окончательный расчёт будет предоставлен менеджером по продажам.</p>
        </form>
      </div>`,
      });

      popup.open();
    });

    $("#tariff-block-link").on("click", function (e) {
      e.preventDefault();
      // scroll to #tariff-block-info
      $("html, body").animate(
        {
          scrollTop: $("#tariff-block-info").offset().top,
        },
        1000
      );

      // add class .is-open to #tariff-block-info
      $("#tariff-block-info .collapsible-panel__content").addClass("is-open");
    });
  }

  validateProductLinks() {
    const links = this.productLinks.find("input[name='product_link']");
    const validation = new Validation();
    let isValid = true;

    links.each((i, link) => {
      if (!validation.isValidUrl(link.value)) {
        isValid = false;
        $(link).next(".error-message").show();
      }
    });

    return isValid;
  }

  checkCartState() {
    $.ajax({
      url: ajax_object.ajax_url,
      method: "POST",
      data: {
        action: "get_cart_items",
      },
      success: (response) => {
        if (response.success && response.data.length > 0) {
          this.enableSubmitButton();
        } else {
          this.disableSubmitButton();
        }
      },
      error: (xhr, status, error) => {
        console.error("Failed to check cart state:", error);
        this.disableSubmitButton();
      },
    });
  }

  enableSubmitButton() {
    this.submitOrderButton.prop("disabled", false);
  }

  disableSubmitButton() {
    this.submitOrderButton.prop("disabled", true);
  }
}

export default Main;
